import React from 'react'
import { Grid } from '@mui/material'

import GiftAnalysisCause from './components/GiftAnalysisCause'
import GiftAnalysisRegion from './components/GiftAnalysisRegion'
import GiftAnalysis from './components/GiftAnalysis'

const ProfileGifts = () => {
  return (
    <Grid container>
      <Grid size={{ xl: 3, lg: 3, md: 12, sm: 12, xs: 12 }}>
        <div className="profile-page-charts-container">
          <GiftAnalysisCause />
          <GiftAnalysisRegion />
        </div>
      </Grid>
      <Grid size={{ xl: 9, lg: 9, md: 12, sm: 12, xs: 12 }}>
        <GiftAnalysis />
      </Grid>
    </Grid>
  )
}

ProfileGifts.isEnabled = ({ isFunderDissolved, hasGifts }) => !isFunderDissolved && hasGifts
ProfileGifts.tabPath = 'giftanalysis'
ProfileGifts.getTabName = t => t.funder.giftAnalysis

export default ProfileGifts
